import { equals } from 'ramda';
import { LOGIN_ROOT } from "src/route_constants";
import { getEnvLocalStorageOverrides } from 'src/utilities/storage';
import SiteSettings from 'src/siteSetting';


/**
 * It's in the name.
 *
 * @param {string} returnToPath - The path the user will come back to
 * after authentication is complete
 * @param {string} queryString - any additional query you want to add
 * to the returnTo path
 */
export const redirectToLogin = (
  returnToPath: string,
  queryString: string = ''
) => {
  const redirectUri = `${returnToPath}${queryString}`;
  window.location.assign(prepareOAuthEndpoint(redirectUri));
};

export interface RevokeTokenSuccess {
  success: true;
}


/**
 * Generate a nonce (a UUID), store it in localStorage for later comparison, then create the URL
 * we redirect to.
 *
 * @param redirectUri {string}
 * @param scope {string}
 */
const prepareOAuthEndpoint = (redirectUri: string, scope = '*') => {
  return genOAuthEndpoint(redirectUri, scope);
};

/**
 * Creates a URL with the supplied props as a stringified query. The shape of the query is required
 * by the Login server.
 *
 * @param redirectUri {string}
 * @param scope {[string=*]}
 * @param nonce {string}
 */

const genOAuthEndpoint = (redirectUri: string, scope = '*') => {
  // If there are local storage overrides, use those. Otherwise use variables set in the ENV.
  const localStorageOverrides = getEnvLocalStorageOverrides();
  const urlRoot = equals('/', redirectUri) ? SiteSettings.generalHomeRoot() : LOGIN_ROOT
  const loginRoot = localStorageOverrides?.loginRoot ?? urlRoot;
  const uri =
    redirectUri.match(/logout/) || equals('/', redirectUri)
      ? ''
      : `?returnTo=${window.btoa(redirectUri)}`;
  return `${loginRoot}${uri}`;
};
